@if (response) {
  <div class="offer-container">
    <div class="img-container">
      <div>
        <img class="offer-img" src="{{ response.image_url }}" />
      </div>
      @if (response.offer_heading; as heading) {
        <div class="img-offer-heading">
          <img src="{{ DEPLOY_URL }}/assets/images/offer.webp" />
          <span>{{ heading }}</span>
        </div>
      }
    </div>
    <div class="offer-info">
      @if (response.code; as code) {
        <div class="code-container">
          {{ code }}
          <img class="code-copy" (click)="copyCode(code)"
            src="{{ DEPLOY_URL }}/assets/images/offer-copy.svg" />
        </div>
      }
      <div class="offer-text-container">
        <span class="offer-text-heading">
          {{ response.offer_text_heading }}
        </span>
        <p class="offer-text">
          {{ response.offer_text }}
        </p>
        <button class="sign-in-btn" (click)="openSignin()">Sign-In</button>
      </div>
      @if (response.code; as code) {
        <div class="code-container-desktop">
          {{ code }}
          <img class="code-copy" (click)="copyCode(code)"
            src="{{ DEPLOY_URL }}/assets/images/offer-copy.svg" />
        </div>
      }
    </div>
  </div>
}